<template>
	<div class="page-body">
		<page-header></page-header>
		<div class="page-wrap">
			<el-scrollbar class="page-main">
				<router-view></router-view>
			</el-scrollbar>
		</div>
		<page-footer></page-footer>
	</div>
</template>

<script>
import pageHeader from './components/header.vue'
import pageFooter from './components/footer.vue'
  
  export default {
    name: "home",
    components: {
			pageHeader,
			pageFooter
		},
    methods: {
    
    },
  };
</script>


<style scoped>
  .page-body{
    font-family: Microsoft YaHei;
  }

</style>
